// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_tDF","cls2":"PremiumBadge-cls2_afK PremiumBadge-cls1_tDF"};